import React, { Fragment } from "react"; 
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import { HeaderThree, ServiceSingle, FooterTwo } from "../containers";

const serviceContent = {
  topImage: "/images/service/sr-d-1-1-mis.jpg",
  heading: "Managed IT Services",
  description: `Our Managed IT Services provide end-to-end technology management for businesses, allowing you to focus on your core operations while we handle your IT infrastructure. 
  We offer proactive monitoring, system maintenance, cloud management, security solutions, and helpdesk support to ensure your IT environment is secure, scalable, and highly available. 
  Our services are tailored to meet the unique needs of your organization, ensuring seamless technology operations and reduced downtime.`,

  middleImage: "/images/service/sr-d-1-2-mits.jpg",
  features: [
    "24/7 IT Infrastructure Monitoring & Support",
    "Cloud Solutions & Management",
    "Cybersecurity & Data Protection",
    "Helpdesk & User Support Services",
    "System Upgrades & Maintenance"
  ],

  challengeHeading: "Challenges in Managed IT Services",
  challengeParagraphs: [
    `Managing an entire IT environment requires expertise across networking, servers, cloud services, cybersecurity, and end-user support. 
    Businesses often face challenges in maintaining uptime, securing sensitive data, and keeping up with evolving technology.`,
    `Our team provides proactive management, rapid incident response, and strategic IT planning to overcome these challenges, ensuring your systems are reliable, secure, and optimized for growth.`
  ],

  bottomImages: [
    "/images/service/sr-d-1-3.jpg",
    "/images/service/sr-d-1-4.jpg"
  ]
};

const ManagedITServices = () => (
  <Fragment>
    <Seo
      title="Managed IT Services | Tech Ayukta"
      description="Tech Ayukta offers Managed IT Services including proactive monitoring, cybersecurity, cloud management, and helpdesk support for businesses."
      keywords="Managed IT Services, IT Support, IT Infrastructure, Cloud Management, Cybersecurity, Tech Ayukta"
      canonical="https://www.techayukta.com/services/managed-it-services"
    />
    <HeaderThree />
    <Breadcrumb
      pageName="Managed IT Services"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    <ServiceSingle
      className="space-top space-extra-bottom"
      serviceContent={serviceContent}
    />
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default ManagedITServices;
